// 可以在此修改项目部分设置
const ajaxBaseUrl = '/api'

export default {
  ajaxBaseUrl,
  imageSrcPrefix: `${ajaxBaseUrl}/platform/system/sysFile/getFileById.ht?fileId=`
}



// WEBPACK FOOTER //
// ./src/config.js